// HOW IT LOOKS IN GOOGLE (S2.4): the title and the meta description cut where Google cuts them, under the
// listing's web address. A price line shows only with a public price (Call for Price has none).
export function GooglePreview({ g }) {
  return (
    <div data-testid="sales-draft-google" className="rounded-lg border border-slate-200 p-3 space-y-1.5">
      <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500">How it looks in Google</div>
      <div className="flex items-center gap-2">
        <span className="w-7 h-7 rounded-full bg-[#B01E28] text-white text-xs font-bold flex items-center justify-center">F</span>
        <div className="leading-tight min-w-0">
          <div data-testid="sales-draft-google-site" className="text-sm text-[#202124]">{g.site}</div>
          <div data-testid="sales-draft-google-crumbs" className="text-xs text-[#4d5156] truncate">{g.crumbs}</div>
        </div>
      </div>
      <div data-testid="sales-draft-google-title" className="text-xl leading-snug text-[#1a0dab] break-words">{g.title || "(no title yet)"}</div>
      {g.price && <div data-testid="sales-draft-google-price" className="text-sm text-[#4d5156]">{g.price}</div>}
      <p data-testid="sales-draft-google-description" className="text-sm text-[#4d5156] break-words">{g.description || "(no meta description yet — Google would pick words from the page)"}</p>
      <p className="text-[11px] text-slate-500">{g.stand_in}.</p>
    </div>
  );
}
